import { render } from "./ChallengeType.vue?vue&type=template&id=3ed183d9&scoped=true"
import script from "./_ChallengeType.js?vue&type=script&lang=js&external"
export * from "./_ChallengeType.js?vue&type=script&lang=js&external"

import "./_ChallengeType.less?vue&type=style&index=0&id=3ed183d9&lang=less&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ed183d9"]])

export default __exports__